import {useMemo} from 'react';
import {useUserProfileContext} from '@/contexts/user-profile';

export const useAdvisorProfileFormMessages = () => {
  const {isVerified, isAdvisorWithUnconfirmedStatus, isAssistantWithoutAdvisor} = useUserProfileContext();

  const messages = useMemo(
    () =>
      [
        {messageKey: 'different-field-detected', show: !isVerified},
        {messageKey: 'advisor-status-not-confirmed', show: isAdvisorWithUnconfirmedStatus},
        {messageKey: 'contact-financial-center', show: true},
        {messageKey: 'advisor-profile-unavailable', show: isAssistantWithoutAdvisor},
      ] as const,
    [isVerified, isAdvisorWithUnconfirmedStatus, isAssistantWithoutAdvisor],
  );

  return messages;
};
